/* eslint-disable */
const getters = {
  getSet(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
